import Button from '@/common/components/base/button/Button';
import MainModal from '@/common/components/base/modal/Modal';
import Typography from '@/common/components/base/typography/Typography';
import EmptyDataImage from '@/modules/Statistics/assets/icons/empty-data.svg?react';
import { Box, Flex } from 'styled-system/jsx';

type EmptyStatisticModalProps = {
  open: boolean;
  closeModal: () => void;
  onConfirm: () => void;
  closeOnBackdrop?: boolean;
};

export default function EmptyStatisticModal({
  open,
  closeModal,
  onConfirm,
  closeOnBackdrop,
}: EmptyStatisticModalProps) {
  return (
    <MainModal
      open={open}
      closeModal={closeModal}
      closeOnBackdrop={closeOnBackdrop}
      closeOnHeaderClick={false}
      title="دسترسی به آمار و عملکرد"
    >
      <Flex direction="column" justifyContent="space-between" gap="24px">
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          gap="12px"
          padding="24px 16px"
          backgroundColor="white"
          borderRadius="12px"
        >
          <EmptyDataImage />

          <Typography
            textStyle="b1"
            fontWeight="bold"
            color="black-1"
            textAlign="center"
          >
            هنوز اطلاعات کافی برای محاسبه عملکرد ندارید
          </Typography>

          <Typography textStyle="b2" color="#646464" textAlign="center">
            پس از رسیدن فعالیت شما به حد نصاب، امتیاز و آمار عملکردتان در این
            بخش محاسبه و نمایش داده می‌شود.
          </Typography>
        </Box>

        <Box>
          <Button fullWidth onClick={onConfirm}>
            متوجه شدم
          </Button>
        </Box>
      </Flex>
    </MainModal>
  );
}
